export default __webpack_public_path__ + "static/media/silver.d7fe56fe.png";